'use strict';

exports.__esModule = true;
exports.updateCurrent = updateCurrent;
exports.sendBatch = sendBatch;
exports.getLocation = getLocation;

var _apiClient = require('../../network/api-client');

var _apiClient2 = _interopRequireDefault(_apiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API = {
  COURIER_LOCATIONS_TRACK: '/courier/locations/track'

  /**
   * Wrapper for `/courier/locations/track` API endpoint
   */

};var location = {
  updateCurrent: updateCurrent,
  sendBatch: sendBatch,
  getLocation: getLocation
};

exports.default = location;

/**
 * Track courier - insert current position (will update current)
 * @param {array} data.coords - Location coordinates
 * @param {string} data.recorded_at - The time the tracking location was recorded
 * @param {number} [data.speed] - The speed in m/s
 * @param {number} [data.accuracy] - The accuracy in m
 * @param {number} [data.heading] - The heading in degrees
 * @returns {promise} empty response, code: 204
 */

function updateCurrent() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return _apiClient2.default.post({ route: API.COURIER_LOCATIONS_TRACK, data: data });
}

/**
 * Track courier - batch send locations (not updating current)
 * @param {array} data - array of objects: { coords: [], recorded_at: "", ... }
 * @returns {promise} empty response, code: 204
 */
function sendBatch() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return _apiClient2.default.post({ route: API.COURIER_LOCATIONS_TRACK, data: data });
}

/**
 * Get courier Location - get current courier location
 * @param {string} id - courier_id
 * @param {boolean} searchByAuthor - If we want to search the courier job by the author
 * @returns {promise} array of coods, code: 200
 */
function getLocation(courierId) {
  var searchByAuthor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return _apiClient2.default.get({
    route: '/courier/' + courierId + '/location',
    params: { searchByAuthor: searchByAuthor }
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/courier/location/location.js
// module id = 1184
// module chunks = 0